import { useDispatch } from "react-redux";
import { setPageTitle } from "../../Store/reducers/Common";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const MastersList = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setPageTitle("Master"));
    }, [dispatch]);
    return (
        <div className="reports-page">
            <ul>
                <li>
                    <Link to="organization-master">
                        <i className="fa-solid fa-arrow-right me-2"></i>
                        Organization Master
                    </Link>
                </li>
                <li>
                    <Link to="division-master">
                        <i className="fa-solid fa-arrow-right me-2"></i>
                        Division Master
                    </Link>
                </li>
                <li>
                    <Link to="sector-master">
                        <i className="fa-solid fa-arrow-right me-2"></i>
                        Sector Master
                    </Link>
                </li>
            </ul>
        </div>
    )
}

export default MastersList;